import React, { useState } from "react";

import { CardLayout, MTable } from "../v3";
import { crmReportColumnHeaders } from "../../pages/report/constants";

export const CrmReportResults = ({ loading = false, data = [] }) => {
  const [searchText, setSearchText] = useState("");

  const handleSearchChange = (searchValue) => setSearchText(searchValue);

  // filter data by search
  const filteredData = data.filter((row) =>
    Object.values(row).some((val) => String(val).toLowerCase().includes(searchText.toLowerCase())),
  );

  return (
    <CardLayout>
      <MTable
        placeholder="Search..."
        searchText={searchText}
        onSearchChange={handleSearchChange}
        showSearchBar
        loading={loading}
        columnHeaders={crmReportColumnHeaders}
        tableRows={filteredData}
        rowCount={filteredData.length}
        hideFooter
      />
    </CardLayout>
  );
};
